import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import SearchBoxController from './src/components/SearchBoxController/SearchBoxController';
import SearchBox from './src/components/SearchBox/SearchBox';
import qs from 'qs';
import './src/components/themes/bootstrap_sbox.css';

const renderSearchBoxController = (props) => {
    return (
        props.serverUrl ? <SearchBoxController {...props} /> : <SearchBox />
    );
}

/**
 * @description Gets the root container for the application
 * @param {string} domSelector - A DOMString (must be a valid CSS selector string)
 * @default '#sbox'
 * @returns DOM Element
 */
function getRoot(domSelector = '#sbox') {
    const root = document.querySelector(domSelector);
    return root;
}

let globalRoot = getRoot();
const shouldAutoRender = globalRoot && globalRoot.getAttribute('data-block-auto-render') !== 'true';


function urlToProps(serverUrl, calendarOpenDirection) {
    /* get the url params as object */
    const paramsOnlyString = serverUrl.substring(serverUrl.indexOf('?') + 1, serverUrl.length); // grab everything after the "?"
    const paramsAsObject = qs.parse(paramsOnlyString, { ignoreQueryPrefix: true, allowDots: true });
    //const paramsAsObject = getParams(paramsOnlyString); // convert to an object
    const { roomCategory, results_roomCategory, ...modifiedParams } = paramsAsObject; // change roomCategory parama name to results_roomCategory (api changed, we dont want breaking changes for current clients 26-03-2018)
    modifiedParams.results_roomCategory = results_roomCategory || roomCategory;
    const props = {
        serverUrl,
        queryStringObj: modifiedParams,
        calendarOpenDirection
    };

    return props;
}

function mount(domSelector, externalProps = {}) {
    const root = getRoot(domSelector);
    if (!root) {
        console.warn(`Cannot find root - ${domSelector}`);
        return null;
    }

    const serverUrl = root.getAttribute('data-url');
    const calendarOpenDirection = root.getAttribute('data-cal-open-dir');

    const props = {
        ...urlToProps(serverUrl, calendarOpenDirection),
        ...externalProps
    };
    const Container = renderSearchBoxController(props);

    return render(Container, root);
}

// cleanup for dom nodes and events
function unmount(domSelector) {
    const root = getRoot(domSelector);
    return root && unmountComponentAtNode(root);
}

// expose render methods (extends existing object)
window.silverbyteDOM = {
    ...window.silverbyteDOM,
    searchbox: { mount, unmount }
};

// in case we want to auto render on page load
if (shouldAutoRender) {
    window.silverbyteDOM.searchbox.mount();
}



// WEBPACK FOOTER //
// ./index.js